import type { JSX } from 'react'

export const ArrowUpIcon = (): JSX.Element => (
  <use href='#arrowUpIcon' height='100%' width='100%' />
)
